export default __webpack_public_path__ + "d3e2c292ad8b46296a5216bc44556786.png";